// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"a013a880","70":"25c33ddc","219":"78513cc8","787":"3bf86b37","844":"984bd78d","848":"9d7f2877"}[chunkId] + ".chunk.js";
};